import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('vision_benefits_set', '/vision_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
